import React from 'react';
import { Section } from './ui/Section';
import { FileText, CheckSquare, Target, MessageSquare, Calendar, Layout } from 'lucide-react';
export function ProductDetails() {
  const includes = [{
    icon: FileText,
    text: 'Protocolo completo paso a paso'
  }, {
    icon: Target,
    text: 'Cómo elegir tu habilidad rentable'
  }, {
    icon: CheckSquare,
    text: 'Cómo crear una oferta high-ticket simple'
  }, {
    icon: MessageSquare,
    text: 'Cómo conseguir prospectos en frío'
  }, {
    icon: MessageSquare,
    text: 'Scripts de mensajes y llamadas'
  }, {
    icon: Calendar,
    text: 'Plan 30–60–90 días'
  }, {
    icon: Layout,
    text: 'Tablero Notion de ejecución'
  }];
  return <Section data-id="element-103">
      <div className="flex flex-col md:flex-row gap-12 items-center" data-id="element-104">
        {/* PDF Preview Visual */}
        <div className="w-full md:w-1/2 relative group" data-id="element-105">
          <div className="absolute inset-0 bg-black translate-x-4 translate-y-4 group-hover:translate-x-2 group-hover:translate-y-2 transition-transform" data-id="element-106"></div>
          <div className="relative bg-gray-100 border-4 border-black p-8 aspect-[3/4] flex flex-col justify-between" data-id="element-107">
            <div className="border-b-4 border-black pb-4" data-id="element-108">
              <h3 className="text-4xl font-bold uppercase leading-none" data-id="element-109">
                Protocolo
                <br data-id="element-110" />
                Antipobreza™
              </h3>
              <p className="font-mono text-sm mt-2" data-id="element-111">EDICIÓN OPERADOR // 2026</p>
            </div>
            <div className="space-y-4 opacity-20" data-id="element-112">
              <div className="h-4 bg-black w-full" data-id="element-113"></div>
              <div className="h-4 bg-black w-5/6" data-id="element-114"></div>
              <div className="h-4 bg-black w-4/6" data-id="element-115"></div>
              <div className="h-4 bg-black w-full" data-id="element-116"></div>
            </div>
            <div className="mt-auto pt-8 border-t-4 border-black" data-id="element-117">
              <p className="font-bold text-xl" data-id="element-118">CONFIDENCIAL</p>
              <p className="text-sm" data-id="element-119">SOLO PARA USO PERSONAL</p>
            </div>
          </div>
        </div>

        {/* Content List */}
        <div className="w-full md:w-1/2" data-id="element-120">
          <h2 className="text-4xl font-bold mb-8 uppercase" data-id="element-121">
            Lo que incluye el PDF
          </h2>
          <ul className="space-y-4 mb-8" data-id="element-122">
            {includes.map((item, idx) => <li key={idx} className="flex items-center text-lg font-medium border-b border-gray-100 pb-2" data-id="element-123">
                <item.icon className="w-6 h-6 mr-4 text-red-600" data-id="element-124" />
                {item.text}
              </li>)}
          </ul>
          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4" data-id="element-125">
            <p className="font-bold text-gray-800" data-id="element-126">
              Formato: PDF directo al grano, diseñado para ejecutar en paralelo
              a tu vida real (no encima de tu vida).
            </p>
          </div>
        </div>
      </div>
    </Section>;
}